/* eslint-disable no-undef */

export function isComingSoonMode() {
  return false;

  // return ['https://happylife.am', 'https://happy-life.am'].includes(
  //   window.origin
  // );
}
